export default {
  AppName: 'باربانت',
  AppTagline: 'پیشخوان مدیریت'
}
